import React, { useEffect, useState, useCallback, useContext, useRef } from "react";
import {
  Divider,
  Tooltip,
  Typography,
  IconButton,
  Badge,
  FormControl,
  Switch,
  FormControlLabel,
  Select,
  MenuItem,
  Box,
  Grid,
  CircularProgress,
  Button
} from "@material-ui/core";
import Modal from "../../cm_shared/cm_global_modal";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import SelectAllIcon from '@material-ui/icons/SelectAll';
import TabUnselectedIcon from '@material-ui/icons/TabUnselected';
import DataTable from "react-data-table-component";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import PublishIcon from "@material-ui/icons/Publish";
import BulkDownloadConfirmationModal from "../../cm_shared/CMBulkDownloadConfirmation/index";
import ScenarioGroupingFlow from "./../ScenarioGroupingFlow";
import VariationsSelection from "../../cm_close_loop/ScenarioListing/selectVariation";
// import options from "./options";
import CustomPagination from "../../cm_shared/CMCustomPagination";
import { Link } from "react-router-dom";
import CMDeleteModal from "../../cm_shared/CMDeleteModal";
import PGScenarioLogicalNameListing from "./../OpenLoopListing/PGScenariosLogicalBased/index";
import HelperComponent from "../../cm_shared/Reporting/CustomHelper/index";
import HelpIcon from "@material-ui/icons/Help";
import CMUpload from "../../cm_close_loop/CMUpload";
import BulkDownloadModal from "../../cm_shared/CMBulkDownloadPopup/index";
import ClearIcon from "@material-ui/icons/Clear";
import { FilterList, NoteAdd as NoteAddIcon } from "@material-ui/icons";
import { LoadingContext } from "./../../../../context/spinnerContext"

import ConditionalFilter from "../../cm_shared/CMConditionalFilter";
import styled from "styled-components";




const parseJSONString = (str) => {
  try {
    return JSON.parse(str.replace(/'/g, '"'));
  } catch (error) {
    return str;
  }
};

const customStyles = {
  table: {
    style: {
      border: "solid 1px rgba(0,0,0,.2)",
      borderRadius: "10px",
    },
  },
  rows: {
    style: {
      cursor: "pointer",
      fontSize: 16,
      paddingTop: "10px",
      paddingBottom: "10px",
      minHeight: "unset"
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      backgroundColor: "#b0ff45",
      justifyContent: "flex-start",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "bold",
      justifyContent: "flex-start",
    },
  },
};

const StyledDataTable = styled(DataTable)`
  .rdt_TableBody {
    overflow: auto;
    max-height: calc(100vh - 430px)
  }
`;
const loadingStyles = makeStyles({
  wrapper: {
    width: "100%",
    height: "100%",
    position: "fixed",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: "2",
  },
  spinner: {
    position: "absolute",
    top: "50%",
    left: "50%",
  },
  fctwToggle: {
    border: '1px solid rgba(0,0,0,.2)',
    height: '56px',
    width: '135px',
    borderRadius: '5px',
    padding: '0.5rem'
  }
});
function PGScenarioListing(props) {
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const classes = loadingStyles();
  const [options, setOptions] = useState([]);
  console.log('rendered on page load---------------');
  const [selectedRows, setSelectedRows] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [downloadConfirm, setDownloadConfirm] = useState(false);
  const [fctwSelected, setFctwSelected] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [scenarioCollectionNew, setScenarioCollectionNew] = useState([]);
  const [selectHandleObj, setSelectHandleObj] = useState({});
  const [scenarioCollectionColumns, setScenarioCollectionColumns] = useState(
    []
  );
  const [advancedSearchString, setAdvancedSearchString] = useState("");
  const [savedFilters, setSavedFilters] = useState([]);
  const [selectedScenarioVariations, setSelectedScenarioVariations] = useState(
    []
  );


  const [allSelect, setAllSelect] = useState(false);
  const [columns, setColumns] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const rowsPerPageSessionBased = [
    10, 20, 50, 100, 200, 300, 500, 700, 1000, 1200, 1500, 1800, 2000, 2500,
    3000,
  ];
  const [eventsPerPage, setEventsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [deleteScenarioUuid, setDeleteScenarioUuid] = useState(null);
  const [disableEscapeKeyDown, setDisableEscapeKeyDown] = useState(false);
  const [isBulkDownloadPopupOpen, setBulkDownloadPopup] = useState(false);
  const [bulkDownloadRes, setBulkDownloadResp] = useState(null);
  const [modalForVariation, setModalForVariation] = useState(false);
  const [disableBackdropClick, setDisableBackdropClick] = useState(false);
  const [clearRows, setClearRows] = useState(false);
  const [allSelected, setAllSelected] = useState(false);
  const [selectValue, setSelectValue] = useState("approved");
  const [modelOptions, setModelOptions] = useState([
    {
      _id: 'approved',
      value: 'Good Data',
    },
    {
      _id: 'bad',
      value: 'Bad Data',
    },
    {
      _id: 'all',
      value: 'All Data',
    }
  ]);
  const [currentFilters, setCurrentFilters] = useState({});
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [currentRowSelection, setCurrentRowSelection] = useState(null);
  const currentFiltersRef = useRef(currentFilters);

  useEffect(() => {
    currentFiltersRef.current = currentFilters;
  }, [currentFilters]);
  const handleClose = () => {
    setIsOpen(false);
  }

  const handleSort = (column, direction) => {
    setCurrentRowSelection(null)
    setSortField(column.selector);
    setSortOrder(direction);
  };

  const handleDeselect = (val) => {
    const { [val]: removedKey, ...rest } = selectHandleObj;
    console.log('removed key', removedKey);
    console.log('rest', rest);
    const uuidToRemove = new Set(removedKey.map(item => item.scenario_uuid));
    console.log('uuidToRemove', uuidToRemove);
    const updatedCart = cartItems.filter(item => !uuidToRemove.has(item.scenario_uuid));
    console.log('updatedCart', updatedCart);
    setCartItems(updatedCart);
    setSelectHandleObj(rest);
  }
  const removeFromHandleObj = (logicalName, uuid) => {
    const updatedArr = selectHandleObj[logicalName].filter(item => item.scenario_uuid !== uuid);
    if (updatedArr.length === 0) {
      const { [logicalName]: removedKey, ...rest } = selectHandleObj;
      console.log('removed key', removedKey);
      console.log('rest', rest);
      setSelectHandleObj(rest);
    } else {
      setSelectHandleObj(preVal => ({
        ...preVal,
        [logicalName]: updatedArr
      }));
    }
  }
  const proceedToGetVariations = async (count, variationName, filters) => {
    console.log("filters inside proceedToGetVariations", filters);

    try {
      setIsLoading(true);
      const response = await axios.post(
        '/cm/open_loop/list_fusion_data_by_logical_name',
        {
          page_number_record: 1,
          page_size_record: count === 'all' ? count : parseInt(count),
          scenarioname_with_variation: variationName,
          grouping: true,
          searchOptions: filters ? filters:{}
        }

      );
      const arrItems = [...cartItems, ...response.data.data];
      const uniqueItems = Array.from(
        new Map(arrItems.map(item => [item.scenario_uuid, item])).values()
      );
      setModalForVariation(false);
      setCartItems(uniqueItems);
      if (count === 'all') onClickClose();
      else {
        if (count > response.data.total_records) {
          setBulkDownloadResp({ body: `For a selected Scenario Variation Name, maximum count of recorded data are ${response.data.total_records}. Those have been added to cart.` })
          setBulkDownloadPopup(true);
        }
        setIsOpen(false);
      }
      updateSelectArr(variationName, response.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  }
  const onClickClose = () => {
    setIsOpen(false);
    setModalForVariation(false);
    setBulkDownloadPopup(false);
  }
  const updateSelectArr = (val, arr) => {
    if (selectHandleObj[val]) {
      const arrItems = [...selectHandleObj[val], ...arr];
      const uniqueItems = Array.from(
        new Map(arrItems.map(item => [item.scenario_uuid, item])).values()
      );
      setSelectHandleObj(preVal => ({
        ...preVal,
        [val]: uniqueItems
      }));
    } else {
      setSelectHandleObj(preVal => ({
        ...preVal,
        [val]: arr
      }));
    }
  }
  const onSelectRow = async (newRow, deSelect = false) => {
    if (deSelect) {
      const index = selectedRows.findIndex(
        (row) => row.scenario_uuid === newRow.scenario_uuid
      );
      const newArray = [
        ...selectedRows.slice(0, index),
        ...selectedRows.slice(index + 1),
      ];
      setSelectedRows(newArray);
    } else setSelectedRows((prev) => [...prev, newRow]);
  };

  const selectAll = async (allRow, currentRow) => {
    const newArray = selectedRows.filter(
      (item1) =>
        !currentRow.some((item2) => item2.scenario_uuid === item1.scenario_uuid)
    );
    setSelectedRows([...newArray, ...allRow]);
  };

  const deselectAll = async (currentRow) => {
    const newArray = selectedRows.filter(
      (item1) =>
        !currentRow.some((item2) => item2.scenario_uuid === item1.scenario_uuid)
    );
    setSelectedRows([...newArray]);
  };

  const bulkDownload = async () => {
    setDownloadConfirm(false);
    console.log("selected PR for bulk download", selectedRows);
    try {
      setIsLoading(true);
      const fileList = selectedRows.flatMap(item => [
        { file: item.honda_mf4_s3_uri },
        { file: item.scenario_path }
      ]);
      const payload = {
        initiated_from: "PG Scenario Listing",
        download_file_name: "PG_Scenarios",
        page_type: "PG",
        files: fileList
      }
      const resp = await axios.post(
        process.env.REACT_APP_API_GATEWAY_URL + "/bulk-download",
        payload
      );
      setBulkDownloadResp(JSON.parse(resp.data));
      setBulkDownloadPopup(true);
    } catch (err) {
      console.log('err', err);
    } finally {
      setClearRows(!clearRows);
      setSelectedRows([]);
      setIsLoading(false);
    }
  };

  const onCloseBulkDownloadPopup = () => {
    setBulkDownloadPopup(false);
    console.log(window.location);
    if (bulkDownloadRes.statusCode === 200) {
      const match = bulkDownloadRes.body.split('name: ')[1];
      window.open(`${window.location.origin}/download_archive_list?latestDownload=${match}`, '_blank');
    }
  }

  const handleSelectAll = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post(
        '/cm/open_loop/fetch_scenarios_for_grouping',
        {
          searchOptions: currentFilters,
          "open_loop_type": "PG",
          fctw: fctwSelected,
        }
      );
      const arrItems = [...cartItems, ...response.data.data];
      const uniqueItems = Array.from(
        new Map(arrItems.map(item => [item.scenario_uuid, item])).values()
      );
      setCartItems(uniqueItems);
      const groupedObj = response.data.data.reduce((acc, obj) => {
        const prefix = obj.variation_name;
        if (!acc[prefix]) {
          acc[prefix] = [];
        }
        acc[prefix].push(obj);
        return acc;
      }, {});
      setSelectHandleObj({ ...selectHandleObj, ...groupedObj });
      response.data.data.length !== 0 && handleModal(
        <ScenarioGroupingFlow
          fctwValue={fctwSelected}
          cartItems={uniqueItems}
          onRemoveFromCart={removeItemForGroup}
          clearCart={() => {
            setCartItems([]);
            setIsOpen(false);
            setSelectHandleObj({});
          }
          }
          handleCloseModal={setIsOpen}
          selectValue={selectValue}
          fromSelectAll={true}
          open_loop_type={"PG"}
        ></ScenarioGroupingFlow>,
        true,
        true
      )
    } catch (err) {
      console.error('error message', err)
    } finally {
      setIsLoading(false);
    }
  };

  const fetchFilterOptions = async () => {
    const response = await axios.post(
      "/cm/close_loop/fetch_filters_for_page_v2",
      // "/cm/open_loop/fetch_filters_for_page_v2",
      {
        page_filter: "open_loop_pg_listing_base_scenario"
      }
    );
    console.log("RESPONSE DATA", response.data)


    let filtersToSet = {}
    const filtersReceived = response.data[0].filters
    Object.entries(filtersReceived).map((filterDetails) => {
      console.log(filterDetails, filterDetails[0], filterDetails[1])
      if (filterDetails[1].visible === true) {
        filtersToSet[filterDetails[0]] = filterDetails[1]
      }
    })

    console.log("filtersToSet", filtersToSet)
    setOptions(filtersToSet)

    // if (response.data.length > 0) {
    //   const defaultSelectValue = response.data[0]._id;
    //   setSelectValue(defaultSelectValue);
    //   setCurrentFilters(
    //     JSON.stringify([{ model_record: [defaultSelectValue] }])
    //   );
    //   fetchScenarioCollectionNew(
    //     JSON.stringify([{ model_record: [defaultSelectValue] }])
    //   );
    // }
  };
  const addItemsForGroup = (row) => {
    setCartItems((prev) => [...prev, row]);
    updateSelectArr(row.scenarioname_with_variation[0], [row]);
  }
  const removeItemForGroup = (rowData) => {
    const index = cartItems.findIndex(
      (row) => row.scenario_uuid === rowData.scenario_uuid
    );
    const newArray = [
      ...cartItems.slice(0, index),
      ...cartItems.slice(index + 1),
    ];
    newArray.length === 0 ? handleDeselect(rowData.scenarioname_with_variation[0]) : removeFromHandleObj(rowData.scenarioname_with_variation[0], rowData.scenario_uuid);
    setCartItems(newArray);
  }
  const isRowExpandable = (row) => {
    return row.quality_check_status !== "bad";
  };
  const conditionalRowStyles = [
    {
      when: row => row.quality_check_status === "bad" && selectValue === 'all',
      style: {
        backgroundColor: '#DCDCDC',
        color: 'black',
        '&:hover': {
          cursor: 'not-allowed',
        },
      }
    }
  ]
  const badTableColumns = [
    {
      name: "Scenario Variation Name",
      selector: "scenarioname_with_variation",
      sortable: true,
      reorder: true,
    },
    {
      name: "Reason For Bad Status",
      selector: "Remarks",
      sortable: true,
      reorder: true,
      cell: (row) => {
        if (row.Remarks === null) {
          return (
            <div>N/A</div>
          )
        }
        else {
          return (
            <>
              {typeof row.Remarks === "string" ? (
                <div>{row.Remarks && row.Remarks}</div>
              ) : (
                <div>{row.Remarks && row.Remarks[0]}</div>
              )}
            </>
          )
        }
      },
    },
    {
      name: "Scenario Count",
      selector: "count",
      sortable: true,
      reorder: true,
    },
    {
      name: "Uploaded At",
      selector: "updated_at",
      sortable: true,
      reorder: true,
      cell: (row) => (
        <div>
          {row.updated_at}
        </div>
      )
    },
  ]
  const initialColumns = [
    {

      name: "Scenario Variation Name",
      selector: "scenarioname_with_variation",
      sortable: true,
      reorder: true,
      grow: 2,
      cell: (row) => (
        <div>{row.scenarioname_with_variation}</div>
      ),
    },
    {
      name: "Scenario Logical Name",
      selector: "scenario_logical_name",
      sortable: true,
      reorder: true,
    },
    {
      name: "Scenario Description",
      selector: "scenarioVariationDiscription",
      sortable: false,
      reorder: true,
      cell: (row) => (
        <div style={{ width: "100%" }}>
          {row.scenario_description &&
            Object.keys(row.scenario_description).map((key) => {
              const parsedValue = parseJSONString(
                row.scenario_description[key].replace(/'/g, '"')
              );
              if (typeof parsedValue === "object" && parsedValue !== null) {
                return (
                  <div key={key}>
                    <strong>{key}:</strong>
                    {Object.keys(parsedValue).map((innerKey) => (
                      <span>{parsedValue[innerKey]} </span>
                    ))}
                  </div>
                );
              }
              return (
                <div key={key}>
                  <strong>{key}:</strong> {row.scenario_description[key]}
                </div>
              );
            })}
        </div>
      ),
    },
    {
      name: "Catalogued Data",
      selector: "catalogued_data",
      sortable: false,
      reorder: true,
      cell: (row) => (
        <div style={{ width: "100%" }}>
          {row.catalogued_data &&
            Object.keys(row.catalogued_data).map((key) => {
              if (typeof row.catalogued_data[key] === "object") {
                return row.catalogued_data[key] ?
                  Object.keys(row.catalogued_data[key]).map((childKey) => {
                    return (
                      <div key={childKey}>
                        <strong>{`${key} ${childKey}`}:</strong> {row.catalogued_data[key][childKey]}
                      </div>
                    );
                  }) : undefined
              }
              return (
                <div key={key}>
                  <strong>{key}:</strong> {row.catalogued_data[key]}
                </div>
              );
            })}
        </div>
      ),
    },

    {
      name: "Scenario Count",
      selector: "count",
      sortable: true,
      reorder: true,
    },
    {
      name: "Actions",
      selector: "actions",
      sortable: false,
      reorder: true,
      width: "200px",
      cell: (row) => {
        return (
          <div>
            {(row.scenarioname_with_variation in selectHandleObj
              && selectHandleObj[row.scenarioname_with_variation].length > 0
              && cartItems.length > 0) ?
              <Tooltip placement="top" title={<h6>Deselect Variations</h6>}>
                <IconButton
                  disabled={row.quality_check_status === 'bad'}
                  onClick={() => handleDeselect(row.scenarioname_with_variation)}
                >
                  <TabUnselectedIcon />
                </IconButton>
              </Tooltip> :
              <Tooltip placement="top" title={<h6>Select Variations</h6>}>
                <IconButton
                  disabled={row.quality_check_status === 'bad'}
                  onClick={() => handleModal(
                    <VariationsSelection
                      logicalName={row.scenarioname_with_variation}
                      // getVariations={proceedToGetVariations}
                      getVariations={(count, date) => proceedToGetVariations(count, date, currentFiltersRef.current)}
                      closeKapDailog={onClickClose}
                    />,
                    true,
                    true,
                    true
                  )}
                >
                  <SelectAllIcon />
                </IconButton>
              </Tooltip>}
          </div>
        );
      },
    },
  ];

  let baseUrl = "data:image/png;base64,";

  const handleResetForm = () => {
    setAdvancedSearchString("");
    setSavedFilters([]);
    setColumns(initialColumns);
    setPage(0);
    // const filters = JSON.stringify([{ model_record: [selectValue] }]);
    setCurrentFilters("{}");
    fetchScenarioCollectionNew("{}");
  };

  const handleFctwToggle = (event) => {
    console.log('event.target.checked', event.target.checked);
    setFctwSelected(event.target.checked);
    setCartItems([]);
    setAdvancedSearchString("");
    setSavedFilters([]);
    setPage(0);
    setCurrentFilters("{}");
  }

  const generateFilterColumns = (filters) => {
    console.log("Inside generate filter columns", filters);
    if (!filters || !Array.isArray(filters)) {
      return [];
    }

    return filters.flatMap((filterGroup) => {
      return Object.keys(filterGroup)
        .map((filterKey) => {
          const filterValues = filterGroup[filterKey];

          if (options[filterKey]) {
            return {
              name: options[filterKey].props.label,
              selector: options[filterKey].selector,
              sortable: true,
              reorder: true,
            };
          }

          return null;
        })
        .filter((column) => column !== null);
    });
  };

  const fetchSelectOptions = async () => {
    const response = await axios.post(
      "/cm/close_loop/fetch-carmaker_model_record_V2"
    );
    setModelOptions(response.data);

    if (response.data.length > 0) {
      const defaultSelectValue = response.data[0]._id;
      setSelectValue(defaultSelectValue);
      setCurrentFilters(
        JSON.stringify([{ model_record: [defaultSelectValue] }])
      );
      fetchScenarioCollectionNew(
        JSON.stringify([{ model_record: [defaultSelectValue] }])
      );
    }
  };

  const handleSelectChange = (event) => {
    const newSelectValue = event.target.value;
    setSelectValue(newSelectValue);
    setPage(0);
    // fetchScenarioCollectionNew('{}');
  };

  const handleAdvancedFilterSearch = (value, savedFiltersPassed) => {
    console.log("handleAdvancedFilterSearch", value);
    // value = [...value, { model_record: [selectValue] }]
    // console.log("updated handleAdvancedFilterSearch", value);

    setAdvancedSearchString(value);
    setSavedFilters(savedFiltersPassed);
    setIsOpen(false);

    // const newColumns = generateFilterColumns(value);
    // console.log("NEW COLUMNS", newColumns);
    // setColumns([
    //   {
    //     name: "Scenario Variation Name",
    //     selector: "scenarioVariationName",
    //     sortable: true,
    //     reorder: true,
    //     cell: (row) => (
    //       <div style={{ flexWrap: "wrap" }}>
    //         {row.scenario_name.split(".csv")[0]}
    //       </div>
    //     ),
    //   },
    //   ...newColumns,
    //   ...initialColumns.filter((column) => column.name !== "Scenario Name"),
    // ]);

    const filters = JSON.stringify(value);
    setCurrentFilters(filters);
    fetchScenarioCollectionNew(filters);
  };

  const handleModal = (content, disableBackdropClick, disableEscapeKeyDown, forVariationSelection = false) => {
    setDisableBackdropClick(disableBackdropClick ? true : false);
    setDisableEscapeKeyDown(disableEscapeKeyDown ? true : false);
    setModalContent(content);
    setIsOpen(true);
    forVariationSelection && setModalForVariation(true);
    console.log('log for handling model open check');
  };

  const handleChangeRowsPerPage = (event) => {
    setEventsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const fetchScenarioCollectionNew = async (filters = currentFilters) => {
    setIsLoading(true);
    let response;
    if (selectValue === 'approved' || selectValue === 'all') {
      response = await axios.post(
        `cm/open_loop/open_loop_list`,
        {
          open_loop_type: "PG",
          page_number_record: page + 1,
          page_size_record: eventsPerPage,
          searchOptions: filters ? filters : {},
          status: selectValue,
          fctw: fctwSelected,
          sort_field_record: sortField,
          sort_order_record: sortOrder
        }
      );
    } else {
      response = await axios.post(
        `cm/open_loop/open_loop_list_bad`,
        {
          open_loop_type: "PG",
          page_number_record: page + 1,
          page_size_record: eventsPerPage,
          searchOptions: filters ? filters : {},
        }
      );
    }
    setScenarioCollectionNew(response.data.data);
    setTotal(response.data.total_records);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchFilterOptions()
  }, []);

  useEffect(() => {
    fetchScenarioCollectionNew();
  }, [eventsPerPage, page, selectValue, fctwSelected,sortOrder,sortField]);

  useEffect(() => {
    if (selectValue === 'bad') setColumns(badTableColumns);
    else setColumns(initialColumns);
  }, [cartItems, selectHandleObj, selectValue]);

  const handleDelete = async (scenarioUuid) => {
    try {
      setIsLoading(true);
      await axios.post(`/cm/close_loop/delete-carmaker-scenario`, scenarioUuid);
      fetchScenarioCollectionNew();
    } catch (error) {
      console.error("Failed to delete the scenario:", error);
    } finally {
      setConfirmDeleteOpen(false);
      setIsLoading(false);
    }
  };

  return (
    <div
      style={{
        padding: "0.6rem",
        position: "relative",
        background: "white",
        margin: "10px",
        borderRadius: "10px",
        height: "calc(100% - 120px)"
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "white",
          padding: "5px",
          width: "100%",
        }}
      >
        <Typography variant="h5">
          <Link to="/welcome">Open Loop </Link>
          {">"} PG {">"} Base Scenario Collection
        </Typography>
        <div>
          <Button
            onClick={handleSelectAll}
            variant="contained"
            style={{
              backgroundColor: selectValue !== 'bad' && "#622AD8",
              color: "#ffffff",
            }}
            disabled={selectValue === 'bad'}
          >
            Select All
          </Button>
          <Tooltip placement="top" title={<h6>Upload</h6>}>
            <IconButton
              onClick={() =>
                handleModal(
                  <CMUpload
                    onSuccess={() => { }}
                    closeModal={setIsOpen}
                    isOpenLoop
                  />,
                  true,
                  true
                )
              }
            >
              <PublishIcon />
            </IconButton>
          </Tooltip>
          <Tooltip placement="top" title={<h6>Handle Cart</h6>}>
            <IconButton
              color="inherit"
              onClick={() =>
                handleModal(
                  <ScenarioGroupingFlow
                    fctwValue={fctwSelected}
                    cartItems={cartItems}
                    onRemoveFromCart={removeItemForGroup}
                    clearCart={() => {
                      setCartItems([]);
                      setIsOpen(false);
                      setSelectHandleObj({});
                    }
                    }
                    handleCloseModal={setIsOpen}
                    selectValue={selectValue}
                    open_loop_type={"PG"}
                  ></ScenarioGroupingFlow>,
                  true,
                  true
                )
              }
            >
              <Badge
                badgeContent={cartItems.length}
                max={5000}
                color="secondary"
              >
                <NoteAddIcon />
              </Badge>
            </IconButton>
          </Tooltip>

          <Tooltip placement="top" title={<h6>Help</h6>}>
            <IconButton
              color="inherit"
              onClick={() =>
                handleModal(
                  <HelperComponent
                    closeHandler={setIsOpen}
                    contentController={[
                      {
                        value: "tutorialVideo",
                        label: "Tutorial",
                        tutorials: [{
                          videoURL: "/video/openlooppg.mp4",
                          text: "In this tutorial, we will have a walkthrough on how to use the open loop PG Scenario Collection.",
                          title: "Open loop | PG | Base Scenario Collection"
                        }]
                      },
                    ]}
                    defaultSelector="tutorialVideo"
                  />,
                  true,
                  true
                )
              }
            >
              <Badge max={5000} color="secondary">
                <HelpIcon />
              </Badge>
            </IconButton>
          </Tooltip>
          {selectedRows.length !== 0 && (
            <Tooltip placement="top" title={<h6>Download</h6>}>
              <IconButton color="inherit" onClick={() => setDownloadConfirm(true)}>
                <Badge
                  badgeContent={selectedRows.length}
                  max={5000}
                  color="secondary"
                >
                  <CloudDownloadIcon />
                </Badge>
              </IconButton>
            </Tooltip>
          )}
        </div>
      </div>
      <Divider />

      {/* <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        content={modalContent}
        size={"lg"}
        disableEscapeKeyDown={disableEscapeKeyDown}
        disableBackdropClick={disableBackdropClick}
      /> */}
      <Modal
        title={modalForVariation && 'Add variation count'}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        content={modalContent}
        size={modalForVariation ? "sm" : "lg"}
        disableEscapeKeyDown={disableEscapeKeyDown}
        disableBackdropClick={disableBackdropClick}
      />
      {isBulkDownloadPopupOpen && <BulkDownloadModal
        title={modalForVariation ? "Cart updated successfully" : "Bulk Download Status"}
        isOpen={isBulkDownloadPopupOpen}
        onClosePopup={modalForVariation ? onClickClose : onCloseBulkDownloadPopup}
        content={bulkDownloadRes.body}
      />}
      {downloadConfirm && <BulkDownloadConfirmationModal
        isOpen={downloadConfirm}
        onClosePopup={setDownloadConfirm}
        onClickYes={bulkDownload}
      />}
      <Grid
        container
        spacing={3}
        style={{
          marginTop: "5px",
          marginBottom: "5px",
          justifyContent: "space-between",
        }}
      >
        <Grid item>
          <Box style={{ display: "flex", gap: "10px" }}>
            {/* <Button
            onClick={() =>
              handleModal(
                <ConditionalFilter
                  options={options}
                  handleAdvancedFilterSearch={handleAdvancedFilterSearch}
                  preSelectedFilters={savedFilters}
                />
              )
            }
            variant="contained"
            style={{ backgroundColor: "#622ad8", color: "white" }}
            startIcon={<FilterList />}
            disabled={true}

          >
            Filter
          </Button>

          <Button
            onClick={handleResetForm}
            variant="outlined"
            startIcon={<ClearIcon />}
            color=""
          >
            Clear
          </Button> */}
            {/* Filter Button */}
            {Object.keys(options).length ?
              <Button
                onClick={() =>
                  handleModal(
                    <ConditionalFilter
                      handleClose={handleClose}
                      options={options}
                      handleAdvancedFilterSearch={handleAdvancedFilterSearch}
                      preSelectedFilters={savedFilters}
                      fctwListShowing={fctwSelected}
                    />
                  )
                }
                variant="contained"
                style={{ backgroundColor: "#622ad8", color: "white" }}
                startIcon={<FilterList />}
              >
                Filter
              </Button> : null}

            {/* Clear */}
            <Button
              onClick={handleResetForm}
              variant="outlined"
              startIcon={<ClearIcon />}
            >
              Clear
            </Button>
            {/* <Modal
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            content={modalContent}
            size={"lg"}
            disableEscapeKeyDown={disableEscapeKeyDown}
            disableBackdropClick={disableBackdropClick}
          /> */}
          </Box>
        </Grid>

        <Grid item>
          <CustomPagination
            total={total}
            rowsPerPageOptions={rowsPerPageSessionBased}
            eventsPerPage={eventsPerPage}
            page={page}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            onPageChange={handlePageChange}
          />
        </Grid>
      </Grid>

      <div style={{ overflowX: "auto" }}>
        <div style={{ display: 'flex', marginBottom: '10px' }}>
          <FormControl
            variant="outlined"
            style={{ minWidth: 200, marginBottom: "10px" }}
          >
            <Select value={selectValue} onChange={handleSelectChange}
              MenuProps={{
                getContentAnchorEl: null,
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left'
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left'
                }
              }}>
              {modelOptions.map((option) => (
                <MenuItem key={option._id} value={option._id}>
                  {option.value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControlLabel
            className={classes.fctwToggle}
            value="start"
            control={
              <Switch
                checked={fctwSelected}
                onChange={handleFctwToggle}
                color="primary"
                name="fctw"
              />
            }
            label="FCTW"
            labelPlacement="start"
          />
        </div>
        {columns.length > 0 ? (
          <StyledDataTable
            columns={columns}
            data={scenarioCollectionNew}
            customStyles={customStyles}
            onSort={handleSort}
            sortServer
            onRowClicked={(row) => setCurrentRowSelection(row)}
            expandableRowExpanded={(rowex) => (rowex === currentRowSelection)}
            onRowExpandToggled={(bool, row) => setCurrentRowSelection(row)}
            expandableRowsComponent={
              <PGScenarioLogicalNameListing
                handleAddToCart={addItemsForGroup}
                handleRemoveFromCart={removeItemForGroup}
                selectedRows={selectedRows}
                cartItems={cartItems}
                allSelect={allSelect}
                onSelectRow={onSelectRow}
                onSelectAllRow={selectAll}
                onDeselectAllRow={deselectAll}
                clearRows={clearRows}
                currentFiltersPassed={currentFiltersRef.current}
              />
            }
            expandableRows
            expandableRowDisabled={row => !isRowExpandable(row)}
            conditionalRowStyles={conditionalRowStyles}
          ></StyledDataTable>
        ) : null}

        <CMDeleteModal
          open={confirmDeleteOpen}
          message="Are you sure you want to delete this scenario?"
          onCancel={() => setConfirmDeleteOpen(false)}
          onConfirm={() => handleDelete(deleteScenarioUuid)}
        />
      </div>
    </div>
  );
}

export default PGScenarioListing;
